import Entity, { IEntity } from '../abstract/Entity';
import { AttachmentAsset } from './AttachmentAsset';
import AttributeModel from './AttributeModel';

export enum AttachmentType {
  PDF = 'PDF',
  IMAGE = 'IMAGE',
  PANORAMA = 'PANORAMA',
  ATTRIBUTE = 'ATTRIBUTE',
}
export type AttachmentPayload = AttributeModel | AttachmentAsset;

export interface IAttachment extends IEntity {
  type: AttachmentType;
  data: AttachmentPayload;
}

class AttachmentModel extends Entity implements IAttachment {
  readonly type: AttachmentType;
  readonly data: AttachmentPayload;

  constructor(type: AttachmentType, data: AttachmentPayload) {
    super();
    this.type = type;
    this.data = data;
  }

  toJSON() {
    return {
      ...super.toJSON(),
      type: this.type,
      data: this.data instanceof AttributeModel ? this.data.toJSON() : this.data,
    };
  }
}

export default AttachmentModel;